// extracted by mini-css-extract-plugin
export default {"iconMore":"MoreButton_iconMore__FEyvg"};